import { AccessRequest, getAccessRequest } from '@infuse/api/iam/access-request';
import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';

export function useAccessRequest() {
  const fetchId = ref<string | undefined>(undefined);

  const query = useQuery<AccessRequest>({
    queryKey: ['access-requests', 'detail', fetchId],
    enabled: () => !!fetchId.value,
    queryFn: () => getAccessRequest({ id: fetchId.value! })
  });

  const accessRequest = computed(() => query.data.value);

  return {
    ...query,
    accessRequest,
    fetchId
  };
}
